import type { UserProfile } from "@/hooks/useUserProfile";

interface UserProfileDetailsProps {
  profile: UserProfile;
}

export const UserProfileDetails = ({ profile }: UserProfileDetailsProps) => {
  return (
    <div className="space-y-2">
      <div>
        <span className="font-medium">Email:</span>{" "}
        {profile.email}
      </div>
      <div>
        <span className="font-medium">Type de compte:</span>{" "}
        {profile.user_type === "admin" ? "Administrateur" : "Propriétaire"}
      </div>
      {profile.ownerData && (
        <>
          <div>
            <span className="font-medium">Nom de l'entreprise:</span>{" "}
            {profile.ownerData.company_name || "Non défini"}
          </div>
          <div>
            <span className="font-medium">Type d'entreprise:</span>{" "}
            {profile.ownerData.business_types?.name || "Non défini"}
          </div>
          <div>
            <span className="font-medium">Devise:</span>{" "}
            {profile.ownerData.currency || "FCFA"}
          </div>
        </>
      )}
      <div>
        <span className="font-medium">ID:</span> {profile.id}
      </div>
    </div>
  );
};